import SearchBar from "../common/SearchBar";
import "../../styles/common.css";
import "../../styles/driverHeader.css";

import { Plus, ShieldCheck } from "lucide-react";

export default function AdminHeader({ total, search, onSearch, onAdd }) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <ShieldCheck size={24} className="primaryIcon" />
            <h2>Administrateurs</h2>
          </div>
          <span className="countBadge">{total} membres</span>
        </div>

        <button className="btnPrimary" onClick={onAdd}>
          Ajouter un admin
          <Plus size={18} style={{ marginLeft: '8px' }} />
        </button>
      </div>

      <div className="filterActionsRow">
        <div className="searchWrapper" style={{ maxWidth: "100%" }}>
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher par nom, email, téléphone..."
          />
        </div>
      </div>
    </div>
  );
}